import Login from "@/pages/Login";

export const API_ENDPOINTS = {
    AUTH: {
        
        SIGNUP: "/api/?activity=SignUp",
        LOGIN: "/api/?activity=Login",
        ADDAUTHORIZEDSIGNATORY: "/api/?activity=AddAuthorizedSignatory",
        SENDOTP: "/api/?activity=SendOtp",
        VERIFYOTP: "/api/?activity=ValidateOtp",
        FORGOT_PASSWORD: "/api/?activity=ForgotPassword",
        RESET_PASSWORD: "/api/?activity=ResetPassword",
        LOGOUT: "/api/?activity=Logout",
        
    },

    PROJECT: {
        TEMPLATE: "/api/?activity=GetProjectDetail",
        DETAILS: "/api/?activity=GetProjectDetail",
        SAVE: "/api/?activity=SaveProject",
        SEARCH: "/api/?activity=SearchProjects",
        UPDATE: "/api/?activity=UpdateProject",
        DELETE: "/api/?activity=DeleteProject",
    },

    PROPERTY: {
        TEMPLATE: "/api/?activity=GetPropertyDetail",
        DETAILS: "/api/?activity=GetPropertyDetail",
        SAVE: "/api/?activity=SaveProperty",
        SEARCH: "/api/?activity=SearchProperties",
        UPDATE: "/api/?activity=UpdateProperty",
        DELETE: "/api/?activity=DeleteProperty",
    },

    BUILDER: {
        DETAILS: "/api/?activity=GetBuilderDetail",
        SAVE: "/api/?activity=SaveBuilderDetail",
        GET_AUTHORIZED_SIGNATORY: "/api/?activity=GetAuthorizedSignatory",
        ADD_AUTHORIZED_SIGNATORY: "/api/?activity=AddAuthorizedSignatory",
        ACCOUNT_STATUS: "/api/?activity=GetBuilderAccountStatus",
    },

    STORAGE: {
        GENERATE_UPLOAD_URL: "/api/?activity=GenerateUploadUrl",
    }


} as const;
